import { render, staticRenderFns } from "./Zippykind.vue?vue&type=template&id=e867b180&scoped=true&"
import script from "./Zippykind.vue?vue&type=script&lang=js&"
export * from "./Zippykind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e867b180",
  null
  
)

export default component.exports